'use client';

import AnimationContainer from '@/components/Animation/AnimationContainer';
import { useEffect, useMemo, useState } from 'react';
import styles from './videoList.module.scss';

interface VideoListProps {
  activeItem: number;
  play: boolean;
  variation: 'default' | 'engineLanding';
}

type Videos = {
  [key in VideoListProps['variation']]: Array<{
    src: string;
    duration: number;
  }>;
};

const videos: Videos = {
  default: [
    {
      src: '/static/animations/animated-list-pennyHelps/animation-1.json',
      duration: 5,
    },
    {
      src: '/static/animations/animated-list-pennyHelps/animation-2.json',
      duration: 5,
    },
    {
      src: '/static/animations/animated-list-pennyHelps/animation-3.json',
      duration: 5,
    },
    {
      src: '/static/animations/animated-list-pennyHelps/animation-4.json',
      duration: 4,
    },
  ],
  engineLanding: [
    {
      src: '/static/animations/animated-list-portal/animation-1.json',
      duration: 12,
    },
    {
      src: '/static/animations/animated-list-portal/animation-2.json',
      duration: 5,
    },
    {
      src: '/static/animations/animated-list-pennyHelps/animation-3.json',
      duration: 5,
    },
    {
      src: '/static/animations/animated-list-pennyHelps/animation-4.json',
      duration: 4,
    },
  ],
};

const fetchAnimation = async (path: string) => {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Failed to fetch animation: ${path}`);
  }
  return response.json();
};

export const VideoList = ({ activeItem, play, variation }: VideoListProps) => {
  const [videoList, setVideoList] = useState<object[]>([]);
  const animationPaths = useMemo(() => videos[variation], [variation]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const fetchedVideos = await Promise.all(
          animationPaths.map((path) => fetchAnimation(path.src))
        );
        setVideoList(fetchedVideos);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching animations:', error);
      }
    };

    fetchVideos();
  }, [animationPaths]);

  return (
    <ul className={`${styles.video_list} ${play ? styles.isActive : ''}`}>
      {videoList.map((video, index) => (
        <li
          className={`${styles.video_container} ${activeItem === index ? styles.isActive : ''}`}
          key={index}
        >
          <AnimationContainer
            animation={video}
            isActive={activeItem === index}
            isList
            duration={animationPaths[index].duration}
            play={play}
          />
        </li>
      ))}
    </ul>
  );
};
